import TnCUploader from "./TnCUploader";
import { connect } from "react-redux";
import { actions } from "./TnCUploaderActions";

export default connect(
  state => ({ postTncState: state.TnCUploaderReducer }),
  actions
)(TnCUploader);
